import * as APIG from 'aws-apig-client'
import AuthService from '../services/auth.service'
import axios from 'axios'
import Crypto from '../encrypt'

const receiverUrl = process.env.VUE_APP_Public_url;
export default class ApiService {
  // constructor(private auth: AuthService, private env: EnvservService) { }
  getPublicData(url) {
    const _url = receiverUrl + url;
    return axios.get(_url)
      .then(response => {
        return response
      })
  }
  postPublicData(url, data) {
    const _url = receiverUrl + url;
    return axios.post(_url, data)
      .then(response => {
        return response
      })
  }
  getIPAddress() {
    return axios.get('https://api.ipify.org?format=json')
      .then(response => {
        return response;
      });
  }

  async getData(method, url, params, body, additionalParams, queryParams) {
    const isLoggedIn = await AuthService.authenticate()
    if (isLoggedIn) {
      const apigClient = APIG.newClient({
        accessKey: AuthService.AccessKeyId,
        secretKey: AuthService.SecretKey,
        sessionToken: AuthService.SessionToken,
        invokeUrl: process.env.VUE_APP_apiUrl,
        region: AuthService.aws_region,
        systemClockOffset: 0,
        retries: 4,
        retryCondition: (err) => {
          return err.response && err.response.status === 500
        },
        retryDelay: 100
      })
      if (additionalParams === null) {
        additionalParams = {
          withCredentials: true,
          headers: {
            'x-amz-usr': `${AuthService.accessToken}`,
            'x-api-key': Crypto.set(AuthService.emailID)
            //'x-api-key':`${AuthService.emailID}`
          }
        }
        if (queryParams) {
          additionalParams.queryParams = queryParams
        }
      }

      return apigClient.invokeApi(params, url, method, additionalParams, body, queryParams)
        .then((result) => {
          return result
        }).catch((result) => {
          if (result && result.response && result.response.status === 403) {
            this.AuthService.authenticate();
            //window.location.href ='https://aenetworks.okta.com/app/'
          }
          else return result;
        })
    }
  }
}
